import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Subject } from 'rxjs/Subject';

import { ApiClient } from '../api-client';
import { Agency } from './agency';

@Injectable()
export class AgencyService extends ApiClient {
  model = Agency;
  store: Subject<Agency[]>;
  path: string = '/agencies';

  constructor(protected http: Http) {
    super(http);
    this.store = <Subject<Agency[]>>new Subject();
  }
}



// WEBPACK FOOTER //
// ./src/app/api/resources/agency.service.ts